import { DAWWorkspace } from '../components/studio/DAWWorkspace';

export const StudioPage = () => {
  return <DAWWorkspace />;
};

export default StudioPage;
